import { GridSortModel } from '@mui/x-data-grid';

export const liveSyncThreshold = 10; // 10 minutes

// Conversations table: rows per page, the backend's search limit, default order
export const DEFAULT_PAGE_SIZE = 25;
export const SEARCH_MAX_LENGTH = 200;
export const DEFAULT_CONVERSATIONS_SORT: GridSortModel = [
  { field: 'start_ts', sort: 'desc' },
];

// Dropdown value for the whole company instead of one agent
export const ALL_AGENTS = '--';
